import { combineReducers } from 'redux';
import authReducer from './authReducer';
import UserReducer from "./UserReducer";
import PermissionReducer from "./PermissionReducer";
import roleReducer from "./roleReducer";
import configReducer from "./configReducer";
import serviceReducer from './serviceReducer';
import customerClassReducer from './customerClassReducer';
import customerStatusReducer from './customerStatusReducer';
import interactionStatusReducer from './interactionStatusReducer';
import interactionTypeReducer from './interactionTypeReducer';
import lookupCustomerReducer from './lookupCustomerReducer';
import PageManagerReducer from './PageManagerReducer';
import regionsReducer from './regionsReducer';
import branchReducer from './branchReducer'
import roleGroupReducer from './roleGroupReducer';
import diseasesReducer from './diseasesReducer';
import bloodGroupReducer from './bloodGroupReducer';
import appointmentReducer from './appointmentReducer';
import receiptReducer from './receiptReducer';
import productReducer from './productReducer';
import ProductGroupReducer from './ProductGroupReducer';
import ProductSupplierReducer from './ProductSupplierReducer';
import ProductWarehouseReducer from './ProductWarehouseReducer';
import ProductReceiptImportReducer from './ProductReceiptImportReducer';
import customerSourceReducer from './customerSourceReducer';
import ProductReceiptExportReducer from './ProductReceiptExportReducer';
import unitReducer from './unitReducer';
import GuideReducer from './GuideReducer';
import WorkReportReducer from './WorkReportReducer';
import productStatusReducer from './productStatusReducer';
import customerProspectsReducer from './customerProspectsReducer';
import PaymentVoucherReducer from './PaymentVoucherReducer';
import ViewPhonenumberReducer from './ViewPhonenumberReducer';
import notificationsReducer from './notificationsReducer';
import CashBookReducer from './CashBookReducer';
import CustDocAssistReducer from './CustDocAssistReducer';
import customerServicesReducer from './customerServicesReducer';
import statisticsReducer from './statisticsReducer';
import relationshipTypeReducer from './relationshipTypeReducer';
import customerGroupReducer from './customerGroupReducer';
import Zalo from './Zalo';
import auditLogReducer from './auditLogReducer';
import laboReducer from '@/redux/reducers/laboReducer';
import laboCaseReducer from '@/redux/reducers/laboCaseReducer';
import feedbackRequestReducer from '@/redux/reducers/feedbackRequestReducer';
import customerReducer from '@/redux/reducers/customerReducer';
import BranchFundReducer from './BranchFundReducer';
import procedureReducer from './procedureReducer';
import filterReducer from './filterReducer';
import orthodonticPlanReducer from './orthodonticPlanReducer';
import cusServiceMilestoneReducer from './cusServiceMilestoneReducer';
import instructionTemplateReducer from './instructionTemplateReducer';
import prescriptionTemplateReducer from './prescriptionTemplateReducer';
import treatmentSessionReducer from './treatmentSessionReducer';
import generalExamReducer from './generalExamReducer';
import orthodonticExamReducer from './orthodonticExamReducer';
import customerCareCategoryReducer from './customerCareCategoryReducer';
import customerCareLogReducer from './customerCareLogReducer';
import customerComplaintReducer from './customerComplaintReducer';
import monitoringReducer from './monitoringReducer';
import telesaleFollowUpReducer from './telesaleFollowUpReducer';
import partnerCustomerReducer from './partnerCustomerReducer';
import doctorCustomerReducer from './doctorCustomerReducer';
import doctorAppointmentReducer from './doctorAppointmentReducer';
import commissionReducer from './commissionReducer';
import commissionPolicyReducer from './commissionPolicyReducer';
import serviceGroupConfigurationReducer from './serviceGroupConfigurationReducer';

const rootReducer = combineReducers({
    auth: authReducer,
    user: UserReducer,
    permission: PermissionReducer,
    roleReducer: roleReducer,
    config: configReducer,
    serviceReducer: serviceReducer,
    customerReducer: customerReducer,
    lookupCustomerReducer: lookupCustomerReducer,
    customerClassReducer: customerClassReducer,
    customerStatusReducer: customerStatusReducer,
    interactionStatusReducer: interactionStatusReducer,
    interactionTypeReducer: interactionTypeReducer,
    PageManagerReducer: PageManagerReducer,
    regionsReducer: regionsReducer,
    branchReducer: branchReducer,
    roleGroupReducer: roleGroupReducer,
    diseasesReducer: diseasesReducer,
    bloodGroupReducer: bloodGroupReducer,
    appointmentReducer: appointmentReducer,
    receiptReducer: receiptReducer,
    productReducer: productReducer,
    ProductGroupReducer: ProductGroupReducer,
    ProductSupplierReducer: ProductSupplierReducer,
    ProductWarehouseReducer: ProductWarehouseReducer,
    ProductReceiptImportReducer: ProductReceiptImportReducer,
    customerSourceReducer: customerSourceReducer,
    ProductReceiptExportReducer: ProductReceiptExportReducer,
    unitReducer: unitReducer,
    WorkReportReducer: WorkReportReducer,
    Guide: GuideReducer,
    productStatusReducer: productStatusReducer,
    customerProspectsReducer: customerProspectsReducer,
    PaymentVoucherReducer: PaymentVoucherReducer,
    ViewPhonenumberReducer: ViewPhonenumberReducer,
    notificationsReducer: notificationsReducer,
    CashBookReducer: CashBookReducer,
    CustDocAssistReducer: CustDocAssistReducer,
    customerServicesReducer: customerServicesReducer,
    statisticsReducer: statisticsReducer,
    relationshipTypeReducer: relationshipTypeReducer,
    customerGroupReducer: customerGroupReducer,
    Zalo: Zalo,
    auditLogReducer: auditLogReducer,
    laboReducer: laboReducer,
    laboCaseReducer: laboCaseReducer,
    feedbackRequestReducer: feedbackRequestReducer,
    BranchFundReducer: BranchFundReducer,
    procedureReducer: procedureReducer,
    filterReducer: filterReducer,
    orthodonticPlanReducer: orthodonticPlanReducer,
    cusServiceMilestoneReducer: cusServiceMilestoneReducer,
    instructionTemplateReducer: instructionTemplateReducer,
    prescriptionTemplateReducer: prescriptionTemplateReducer,
    treatmentSessionReducer: treatmentSessionReducer,
    generalExamReducer: generalExamReducer,
    orthodonticExamReducer: orthodonticExamReducer,
    customerCareCategoryReducer: customerCareCategoryReducer,
    customerCareLogReducer: customerCareLogReducer,
    customerComplaintReducer: customerComplaintReducer,
    monitoringReducer: monitoringReducer,
    telesaleFollowUpReducer: telesaleFollowUpReducer,
    partnerCustomerReducer: partnerCustomerReducer,
    doctorCustomerReducer: doctorCustomerReducer,
    doctorAppointmentReducer: doctorAppointmentReducer,
    commissionReducer: commissionReducer,
    commissionPolicyReducer: commissionPolicyReducer,
    serviceGroupConfigurationReducer: serviceGroupConfigurationReducer
});

export default rootReducer;
